<div fxLayout="row" fxLayoutAlign="center center" fxFlex="100">
    <div class="notification-details" fxLayout="column" fxFlex="80" *ngIf="notification" fxLayoutGap="20">
      <div fxLayout="row" fxFlex="100">
        <div fxFlex="100" fxLayoutAlign="start">
          <h2 mat-dialog-title class="title">Notification Details</h2>
        </div>
        <div fxLayoutAlign="end center" fxLayoutGap="10px">
          <button mat-icon-button class="close-icon" (click)="navigateBack()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
  
      <div class="push-content" fxLayout="row" fxLayoutAlign="center center">
        <table class="full-width-table">
          <thead>
            <tr>
              <th>Language</th>
              <th>Title</th>
              <th>Body</th>
              <th>Redirect URL</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="notification.push.en">
              <td>English</td>
              <td>{{notification.push.en.push_title}}</td>
              <td>{{notification.push.en.push_body}}</td>
              <td><a [href]="notification.push.en.redirect_url" target="_blank">{{notification.push.en.redirect_url}}</a></td>
            </tr>
            <tr *ngIf="notification.push.fr">
              <td>French</td>
              <td>{{notification.push.fr.push_title}}</td>
              <td>{{notification.push.fr.push_body}}</td>
              <td><a [href]="notification.push.fr.redirect_url" target="_blank">{{notification.push.fr.redirect_url}}</a></td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20">
        <div class="detail-label" fxFlex="10">Test Emails:</div>
        <div class="detail-value" fxFlex="100">
          <input type="text" [(ngModel)]="testEmails" placeholder="Enter comma separated emails" fxFlex="100">
        </div>
      </div>
  
      <div fxFlex="100" fxLayout="row">
        <div *ngIf="errorMessage" class="error-message" fxFlex="20">{{errorMessage}}</div>
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="end">
          <button mat-raised-button class="mat-button-test" (click)="testNotification()">Test</button>
        </div>
      </div>
    </div>
  </div>
  